import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { thunkFetchStores } from "../../store/stores/actions";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { useI18n } from "../../hooks/useI18n";
import { Store } from "../../models/Store";
import { StoresState } from "../../store/stores/types";

interface State {
  selectedStores: string[];
  selectAll: boolean;
}

interface Props {
  style?: any;
  className?: any;
  selectedStoreIds?: string[];
  onSelectedStore: (storeId: string[]) => void;
}

export const StoreSelector: React.FunctionComponent<Props> = ({
  style,
  className,
  selectedStoreIds,
  onSelectedStore
}) => {
  const dispatch = useDispatch();
  const { t } = useI18n();

  const [state, setState] = useState<State>({
    selectedStores: selectedStoreIds || [],
    selectAll: false
  });

  const storesState = useSelector<AppState, StoresState>(s => s.stores);
  let { stores } = storesState;

  const tenants =
    stores.length > 0
      ? stores
          .filter(
            store => store.state === "Opened" || store.state === "InSetup"
          )
          .reduce((tenantResult: any, store) => {
            const {
              cluster: { name }
            } = store;

            if (!tenantResult[name]) {
              tenantResult[name] = [store];
            } else {
              tenantResult[name] = [...tenantResult[name], store];
            }

            return tenantResult;
          }, {})
      : [];

  const onCheckAllChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedStores = e.target.checked
      ? stores
          .filter(
            store => store.state === "Opened" || store.state === "InSetup"
          )
          .map(s => s.id)
      : [];
    setState({
      selectedStores: selectedStores,
      selectAll: e.target.checked
    });
    onSelectedStore(selectedStores);
  };

  const onChange = (e: any) => {
    const selectedStores = e.target.checked
      ? [...state.selectedStores, e.target.value]
      : state.selectedStores.filter(storeId => storeId !== e.target.value);

    setState({
      selectAll: false,
      selectedStores: selectedStores
    });

    onSelectedStore(selectedStores);
  };

  useEffect(() => {
    dispatch(thunkFetchStores());
  }, []);

  return (
    <div>
      <div
        className={className}
        style={{
          marginBottom: 20,
          borderBottom: "1px solid #e9e9e9",
          ...style
        }}
      >
        <FormControlLabel
          control={<Checkbox onChange={onCheckAllChange} color="primary" />}
          label={t("common.actions.select")}
        />
      </div>
      {Object.keys(tenants).map(clusterName => (
        <div key={clusterName} style={{ marginBottom: 20 }}>
          <div>
            {stores
              .filter(
                store => store.state === "Opened" || store.state === "InSetup"
              )
              .filter(s => s.cluster.name == clusterName)
              .map(store => {
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        key={store.id}
                        value={store.id}
                        onChange={onChange}
                        color="primary"
                        checked={state.selectedStores.includes(store.id)}
                      />
                    }
                    label={store.name}
                  />
                );
              })}
          </div>
        </div>
      ))}
    </div>
  );
};
